import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-person-operation-panel-default",
  templateUrl: "./operation-panel-default.component.html",
  styleUrls: ["./operation-panel-default.component.css"],
})
export class PersonOperationPanelDefaultComponent {
  // 親コンポーネントからの入力
  @Input() selectedCount: number = 0;
  @Input() questionCategory: any[] = [];

  // 親コンポーネントへのイベント通知
  @Output() onMail = new EventEmitter<void>();
  @Output() onShowList = new EventEmitter<void>();
  @Output() differencialDownloadChange = new EventEmitter<boolean>();

  // チェックボックスの状態変更を通知
  onDiffChange(val: boolean) {
    this.differencialDownloadChange.emit(val);
  }
}



// WEBPACK FOOTER //
// ./src/app/a0108-person/operation-panel/default/operation-panel-default.component.ts